import React from "react";
import Card from "./Card";

function rankLabel(index) {
  if (index === 0) return "1st Best Match";
  if (index === 1) return "2nd Best Match";
  if (index === 2) return "3rd Best Match";
  return "Other Good Option";
}

function Results(props) {
  const list = props.results || [];
  const topResults = list.slice(0, 4);

  return (
    <div className="panel fadeIn">
      <div className="resultsHeader">
        <div>
          <h2>Your Recommendations</h2>
          <p className="subtle">
            Based on your profile and preferences.
          </p>
        </div>
        <button className="ghostBtn" onClick={props.onRestart}>
          Start Over
        </button>
      </div>

      {topResults.length === 0 ? (
        <div className="emptyBox">
          No recommendations available. Try adjusting your answers.
        </div>
      ) : (
        <div className="resultsList">
          {topResults.map((item, idx) => (
            <Card
              key={idx}
              item={item}
              label={rankLabel(idx)}
              delayMs={idx * 100}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default Results;
